<app-preview-header>
  <div backBtn>
    <button class="round-btn btn-back" (click)="onBack()">
      <i class="ftmi-arrow-left"></i>
    </button>
  </div>
  <span previewTitle>{{ 'MY_PROFILE' | translate }}</span>
</app-preview-header>

<div class="preview-container">
  <ng-container *ngIf="user">
    <div class="container">
      <app-employee-dashboard *appHasAnyAuthority="[authority.Admin, authority.Teacher, authority.Staff]" [user]="user">
      </app-employee-dashboard>
      <app-student-dashboard *appHasAnyAuthority="authority.Student" [user]="user"> </app-student-dashboard>
    </div>
  </ng-container>
</div>
